import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryUnmatchedStatementItems } from '../../models'

export interface IUseUnmatchedStatementItemListPresenterParams {
  accountId: number
  /** Suggested-match filter — sibling CC item id (BHV-037) */
  filterByCcItemId?: Nullable<number>
}

/**
 * Exposes `totalAmount` and the unmatched count to the Feature Set —
 * React Query dedupes with the rendered presenter via the shared
 * `unmatched` query config.
 */
export const useUnmatchedStatementItemListPresenter = ({
  accountId,
  filterByCcItemId = null,
}: IUseUnmatchedStatementItemListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { items, totalAmount, unmatchedCount, isLoading } =
    useQueryUnmatchedStatementItems({
      accountId,
      matchCreditcardItemId: filterByCcItemId,
      onError: (err) => {
        toast.error({
          title: intl.formatMessage(messages.errorTitle),
          children:
            getMessageFromError(err) ??
            intl.formatMessage(messages.genericErrorMessage),
        })
      },
    })

  return {
    data: {
      items,
      totalAmount,
      unmatchedCount,
    },
    states: {
      isLoading,
    },
  }
}
